export const windowSize = { desk: 1024, tablet: 768, mobile: 500 };
